// Reasons a timeslot blocker can be requested/created with.
//
// Blockers cover organisational situations only (summer party, meeting, no staff, …).
// A blocker caused by a defect must be reported as an issue instead — the outage
// board ("Ausfall-Board") then creates and releases the blockers on its own. The
// catalogue therefore deliberately contains no "defect" entry.
//
// Mirror of `api/internal-booking/blocker-reasons.js` in funzone-management-backend,
// which validates the keys and composes the stored reason text — keep both in sync.
export const BLOCKER_REASON_OTHER = 'other';

export const BLOCKER_REASON_OPTIONS = [
  { key: 'event', label: 'Veranstaltung / Firmenfeier (z. B. Sommerfest)' },
  { key: 'meeting', label: 'Besprechung / Meeting' },
  { key: 'training', label: 'Schulung / Einarbeitung' },
  { key: 'staffShortage', label: 'Kein Personal verfügbar' },
  { key: 'maintenance', label: 'Geplante Wartung / Instandhaltung' },
  { key: 'cleaning', label: 'Reinigung / Auf- und Umbau' },
  { key: 'closure', label: 'Feiertag / Betriebsferien / Schließtag' },
  { key: 'privateEvent', label: 'Exklusiv- / Privatveranstaltung' },
  { key: 'externalBooking', label: 'Buchung über einen anderen Kanal' },
  { key: 'capacityReserve', label: 'Kapazität bewusst freihalten (Puffer)' },
  { key: BLOCKER_REASON_OTHER, label: 'Anderer Grund' },
];
